import React from 'react'
import { connect } from 'react-redux'
import Validator from 'validatorjs'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'
import { getMakerName, getBrandName, getModelName } from 'utils/vehicle'

import { VEHICLE_MAKERS_URL, VEHICLE_DETAIL_URL } from 'constants'

import Input from 'components/Input'
import Button from 'components/Button'

import { vehicleChanged } from 'scenes/VehicleDetail/actions'
import { edittingDataChanged } from 'scenes/VehicleDetail/components/Data/actions'
import { statusChanged } from 'components/RequestStatus/actions'

export class EditForm extends BaseComponent {
  static validationRules = {
    engine_id: 'string|required',
    plates: 'string|required',
    serial_number: 'string|required'
  }

  constructor(props) {
    super(props)
    const vehicle = this.props.vehicle

    this.state = {
      buttonProps: {
        disabled: false
      },
      makers: [],
      formData: {
        engine_id: vehicle.engine_id,
        plates: vehicle.plates,
        serial_number: vehicle.serial_number,
        alias: vehicle.alias
      },
      errors: {}
    }

    this._bind('_onSubmit', '_onInputChange')
  }

  componentDidMount() {
    request(VEHICLE_MAKERS_URL(''))
      .then((res) => {
        this.setState({
          makers: res.makers
        })
      })
  }

  _onSubmit(evt) {
    evt.preventDefault()
    this.props.edittingDataChanged(false)
    this.props.updateRequestStatus('progress', 'Actualizando datos...')

    request(VEHICLE_DETAIL_URL(this.props.userId, this.props.vehicleId), {
      method: 'PUT',
      body: { ...this.state.formData }
    })
    .then((res) => {
      this.props.vehicleChanged(res.vehicle)
      this.props.updateRequestStatus(res.status, res.message)
    })
    .catch((res) => {
      const errors = !!res.fields ? {...res.fields} : {}
      this.props.updateRequestStatus(res.status, res.message)
      this.setState({ errors })
    })
  }

  _onInputChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    let formData = {
      ...this.state.formData,
      [name]: value
    }

    const validator = new Validator(formData, EditForm.validationRules)

    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  render() {
    const vehicle = this.props.vehicle
    let makers = []
    for (let i = 0; i < this.state.makers.length; i++) {
      makers.push({
        value: this.state.makers[i].id,
        label: this.state.makers[i].name,
      })
    }

    return (
      <form onSubmit={this._onSubmit} className="VehicleData__form">
        <div className="form-field">
          <label>Marca:</label>
          <p>{getMakerName(vehicle)}</p>

        </div>
        <div className="form-field">
          <label>Linea:</label>
          <p>{getBrandName(vehicle)}</p>
        </div>
        <div className="form-field">
          <label>Modelo:</label>
          <p>{getModelName(vehicle)}</p>
        </div>
        <div className="form-field">
          <label>Número de motor:</label>
            <Input
              placeholder="Número de motor"
              value={this.state.formData.engine_id}
              name="engine_id"
              onChange={this._onInputChange}
              errors={this.state.errors.engine_id}
            />
        </div>
        <div className="form-field">
          <label>Número de serie:</label>
            <Input
              placeholder="Número de serie"
              value={this.state.formData.serial_number}
              name="serial_number"
              onChange={this._onInputChange}
              errors={this.state.errors.serial_number}
            />
        </div>
        <div className="form-field">
          <label>Placas:</label>
            <Input
              placeholder="Placas"
              value={this.state.formData.plates}
              name="plates"
              onChange={this._onInputChange}
              errors={this.state.errors.plates}
            />
        </div>
        <div className="form-field">
          <label>Alias:</label>
            <Input
              placeholder="Alias"
              value={this.state.formData.alias}
              name="alias"
              onChange={this._onInputChange}
              errors={this.state.errors.alias}
            />
        </div>

        <div className="controls d-flex justify-content-end">
          <Button {...this.state.buttonProps} size="small">Actualizar datos</Button>
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.vehicleDetail.get('vehicle').toObject(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    vehicleChanged: (vehicle) => dispatch(vehicleChanged(vehicle)),
    edittingDataChanged: (edittingData) => dispatch(edittingDataChanged(edittingData)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditForm)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/VehicleData/EditForm.js